"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpCardHeader: {
        viewAsDataTable: 'View as data table',
    },
};
